import React from "react";
import { CONTACT } from "../data";

const Footer = () => {
  return (
    <footer className="relative py-16 border-t" style={{ borderColor: "var(--ocean-border)" }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 flex items-center justify-center" style={{ background: "var(--ocean-accent)", color: "#04111E" }}>
              <span className="font-display font-semibold text-lg">A</span>
            </div>
            <div className="font-display text-xl">Apecatu Expedições</div>
          </div>
          <p className="text-sm" style={{ color: "var(--ocean-muted)" }}>
            Living aboard de mergulho no Arquipélago de Abrolhos, saindo de Caravelas — Bahia desde sempre.
          </p>
        </div>

        <div>
          <div className="overline mb-3">Contato</div>
          <div className="text-sm space-y-1.5">
            <div>{CONTACT.name}</div>
            <div style={{ color: "var(--ocean-muted)" }}>WhatsApp: {CONTACT.phone}</div>
            <a href={`mailto:${CONTACT.email}`} className="block" style={{ color: "var(--ocean-primary)" }} data-testid="footer-email-link">
              {CONTACT.email}
            </a>
          </div>
        </div>

        <div>
          <div className="overline mb-3">Saídas 2026 · 2027</div>
          <div className="text-sm space-y-1.5" style={{ color: "var(--ocean-muted)" }}>
            <div>2 dias / 1 pernoite</div>
            <div>3 dias / 2 pernoites</div>
            <div>4 dias / 3 pernoites</div>
            <div className="pt-2 text-xs">Saída do cais próprio em Caravelas às 07:00</div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t flex flex-col md:flex-row justify-between items-center gap-3 text-xs" style={{ borderColor: "var(--ocean-border)", color: "var(--ocean-muted)" }}>
        <div>© 2026 Apecatu Expedições · Todos os direitos reservados</div>
        <div>Catamarã ZEUS · 50' · 12 pessoas</div>
      </div>
    </footer>
  );
};

export default Footer;